import Vue from 'vue'
import { HTTP_DELETE, HTTP_GET, HTTP_POST, HTTP_PUT } from '../const';
import {
  CANCEL_CLAIM, CANCEL_ORDER,
  EDIT_ORDER,
  FINISH_ORDER,
  LOAD_ORDERS_LIST, OPEN_CLAIM, REFINISH_ORDER,
  RESET_ORDERS, RESTART_FINISH_ERROR_ORDERS, SWITCH_NOTE,
} from '../const/orders';

export default {
  namespaced: true,
  state: {
    orders: {
      pagination: {},
      orders: [],
    },
    ads: [],
    deals: [],
    finishReasons: {
      'duplicate': { description: 'Дубликат', availableOption: false },
      'compensation': { description: 'Компенсация по заявке', availableOption: false },
      'timeout': { description: 'Просрочка заявки', availableOption: false },
      'ticket': { description: 'Решение из чата', availableOption: true },
      'deal': { description: 'Закрытие сделки', availableOption: false },
      'claim': { description: 'Закрытие претензии', availableOption: false },
    },
  },
  getters: {
    orders: state => state.orders,
    ads: state => state.ads,
    deals: state => state.deals,
    finishReasons: state => state.finishReasons,
  },
  actions: {
    [LOAD_ORDERS_LIST]: async ({ dispatch }, { params }) => {
      await dispatch(HTTP_GET, {
        method: LOAD_ORDERS_LIST,
        namespace: 'orders',
        params,
      }, { root: true });
    },
    [EDIT_ORDER]: async ({ dispatch }, { id, data }) => {
      const request = await dispatch(HTTP_PUT, {
        method: EDIT_ORDER,
        namespace: 'orders',
        body: { data },
        replace: { id: id },
        no_commit: true,
      }, { root: true });
      return request;
    },
    [FINISH_ORDER]: async ({ dispatch }, { id, data }) => {
      const request = await dispatch(HTTP_PUT, {
        method: FINISH_ORDER,
        namespace: 'orders',
        replace: { id: id },
        body: data,
        no_commit: true,
      }, { root: true });
      return request;
    },
    [REFINISH_ORDER]: async ({ dispatch }, id) => {
      const request = await dispatch(HTTP_PUT, {
        method: REFINISH_ORDER,
        namespace: 'orders',
        replace: { id },
        no_commit: true,
      }, { root: true });
      return request;
    },
    [CANCEL_ORDER]: async ({ dispatch }, id) => {
      const request = await dispatch(HTTP_PUT, {
        method: CANCEL_ORDER,
        namespace: 'orders',
        replace: { id },
        no_commit: true,
      }, { root: true });
      return request;
    },
    [OPEN_CLAIM]: async ({ dispatch }, { id, data }) => {
      const request = await dispatch(HTTP_POST, {
        method: OPEN_CLAIM,
        namespace: 'orders',
        replace: { id: id },
        body: data,
        no_commit: true,
      }, { root: true });
      return request;
    },
    [CANCEL_CLAIM]: async ({ dispatch }, { id }) => {
      const request = await dispatch(HTTP_DELETE, {
        method: CANCEL_CLAIM,
        namespace: 'orders',
        replace: { id: id },
        no_commit: true,
      }, { root: true });
      return request;
    },
    [SWITCH_NOTE]: async ({ dispatch }, { id, type }) => {
      const request = await dispatch(HTTP_PUT, {
        method: SWITCH_NOTE,
        namespace: 'orders',
        replace: { id, type },
        no_commit: true,
      }, { root: true });
      return request;
    },
    [RESTART_FINISH_ERROR_ORDERS]: async ({ dispatch }, days) => {
      const request = await dispatch(HTTP_POST, {
        method: RESTART_FINISH_ERROR_ORDERS,
        namespace: 'orders',
        body: { days },
        no_commit: true,
      }, { root: true });
      return request;
    },
  },
  mutations: {
    [LOAD_ORDERS_LIST]: (state, { data }) => {
      if (data) {
        Vue.set(state.orders, 'orders', data.orders);
        Vue.set(state.orders, 'pagination', data.pagination);
      }
    },
    [RESET_ORDERS]: (state) => {
      Vue.set(state, 'orders', { pagination: {}, orders: []});
    }
  },
};
